module.exports = __webpack_public_path__ + "static/img/map.29572b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/app/map.png
// module id = pnsY
// module chunks = 1